
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as indexutcnovDtlEMeta } from "/vercel/path0/pages/about/index.vue?macro=true";
import { default as _91diaryId_93Q7u84oSRvCMeta } from "/vercel/path0/pages/diaries/[diaryId].vue?macro=true";
import { default as datewJjPkEYeOEMeta } from "/vercel/path0/pages/diaries/date.vue?macro=true";
import { default as indexuCCr2NntqZMeta } from "/vercel/path0/pages/diaries/index.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as logint0AWlhQgM0Meta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as indexc8KQF5U5F4Meta } from "/vercel/path0/pages/notifications/index.vue?macro=true";
import { default as _91topicId_935k3F9pPwSOMeta } from "/vercel/path0/pages/posts/[topicId].vue?macro=true";
import { default as indexG7XwsIruPAMeta } from "/vercel/path0/pages/posts/index.vue?macro=true";
import { default as editMwostREqPyMeta } from "/vercel/path0/pages/profile/edit.vue?macro=true";
import { default as indexSsrwCXeuTQMeta } from "/vercel/path0/pages/profile/index.vue?macro=true";
import { default as _91storyId_93eZkBdcenCGMeta } from "/vercel/path0/pages/repost/[storyId].vue?macro=true";
import { default as _91diaryId_93MiQpP8amHJMeta } from "/vercel/path0/pages/rewrite/[diaryId].vue?macro=true";
import { default as _91storyId_93jTQHLDc10KMeta } from "/vercel/path0/pages/stories/[storyId].vue?macro=true";
import { default as index9OiDgfx7OcMeta } from "/vercel/path0/pages/terms/index.vue?macro=true";
import { default as _91topicId_93J4gYD96o25Meta } from "/vercel/path0/pages/topics/[topicId].vue?macro=true";
import { default as _91date_93J39kcWxNzgMeta } from "/vercel/path0/pages/write/[date].vue?macro=true";
import { default as component_45stub0StuoQ5MXtMeta } from "/vercel/path0/node_modules/.pnpm/nuxt@3.15.0_@parcel+watcher@2.5.0_@types+node@20.17.11_db0@0.2.1_eslint@9.17.0_jiti@2.4.2__io_7aw6rho5knydylvhygiysfabam/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub0StuoQ5MXt } from "/vercel/path0/node_modules/.pnpm/nuxt@3.15.0_@parcel+watcher@2.5.0_@types+node@20.17.11_db0@0.2.1_eslint@9.17.0_jiti@2.4.2__io_7aw6rho5knydylvhygiysfabam/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about___tw",
    path: "/about",
    meta: indexutcnovDtlEMeta || {},
    component: () => import("/vercel/path0/pages/about/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: indexutcnovDtlEMeta || {},
    component: () => import("/vercel/path0/pages/about/index.vue")
  },
  {
    name: "diaries-diaryId___tw",
    path: "/diaries/:diaryId()",
    meta: _91diaryId_93Q7u84oSRvCMeta || {},
    component: () => import("/vercel/path0/pages/diaries/[diaryId].vue")
  },
  {
    name: "diaries-diaryId___en",
    path: "/en/diaries/:diaryId()",
    meta: _91diaryId_93Q7u84oSRvCMeta || {},
    component: () => import("/vercel/path0/pages/diaries/[diaryId].vue")
  },
  {
    name: "diaries-date___tw",
    path: "/diaries/date",
    meta: datewJjPkEYeOEMeta || {},
    component: () => import("/vercel/path0/pages/diaries/date.vue")
  },
  {
    name: "diaries-date___en",
    path: "/en/diaries/date",
    meta: datewJjPkEYeOEMeta || {},
    component: () => import("/vercel/path0/pages/diaries/date.vue")
  },
  {
    name: "diaries___tw",
    path: "/diaries",
    meta: indexuCCr2NntqZMeta || {},
    component: () => import("/vercel/path0/pages/diaries/index.vue")
  },
  {
    name: "diaries___en",
    path: "/en/diaries",
    meta: indexuCCr2NntqZMeta || {},
    component: () => import("/vercel/path0/pages/diaries/index.vue")
  },
  {
    name: "index___tw",
    path: "/",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "login___tw",
    path: "/login",
    meta: logint0AWlhQgM0Meta || {},
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: logint0AWlhQgM0Meta || {},
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "notifications___tw",
    path: "/notifications",
    meta: indexc8KQF5U5F4Meta || {},
    component: () => import("/vercel/path0/pages/notifications/index.vue")
  },
  {
    name: "notifications___en",
    path: "/en/notifications",
    meta: indexc8KQF5U5F4Meta || {},
    component: () => import("/vercel/path0/pages/notifications/index.vue")
  },
  {
    name: "posts-topicId___tw",
    path: "/posts/:topicId()",
    meta: _91topicId_935k3F9pPwSOMeta || {},
    component: () => import("/vercel/path0/pages/posts/[topicId].vue")
  },
  {
    name: "posts-topicId___en",
    path: "/en/posts/:topicId()",
    meta: _91topicId_935k3F9pPwSOMeta || {},
    component: () => import("/vercel/path0/pages/posts/[topicId].vue")
  },
  {
    name: "posts___tw",
    path: "/posts",
    component: () => import("/vercel/path0/pages/posts/index.vue")
  },
  {
    name: "posts___en",
    path: "/en/posts",
    component: () => import("/vercel/path0/pages/posts/index.vue")
  },
  {
    name: "profile-edit___tw",
    path: "/profile/edit",
    meta: editMwostREqPyMeta || {},
    component: () => import("/vercel/path0/pages/profile/edit.vue")
  },
  {
    name: "profile-edit___en",
    path: "/en/profile/edit",
    meta: editMwostREqPyMeta || {},
    component: () => import("/vercel/path0/pages/profile/edit.vue")
  },
  {
    name: "profile___tw",
    path: "/profile",
    meta: indexSsrwCXeuTQMeta || {},
    component: () => import("/vercel/path0/pages/profile/index.vue")
  },
  {
    name: "profile___en",
    path: "/en/profile",
    meta: indexSsrwCXeuTQMeta || {},
    component: () => import("/vercel/path0/pages/profile/index.vue")
  },
  {
    name: "repost-storyId___tw",
    path: "/repost/:storyId()",
    meta: _91storyId_93eZkBdcenCGMeta || {},
    component: () => import("/vercel/path0/pages/repost/[storyId].vue")
  },
  {
    name: "repost-storyId___en",
    path: "/en/repost/:storyId()",
    meta: _91storyId_93eZkBdcenCGMeta || {},
    component: () => import("/vercel/path0/pages/repost/[storyId].vue")
  },
  {
    name: "rewrite-diaryId___tw",
    path: "/rewrite/:diaryId()",
    meta: _91diaryId_93MiQpP8amHJMeta || {},
    component: () => import("/vercel/path0/pages/rewrite/[diaryId].vue")
  },
  {
    name: "rewrite-diaryId___en",
    path: "/en/rewrite/:diaryId()",
    meta: _91diaryId_93MiQpP8amHJMeta || {},
    component: () => import("/vercel/path0/pages/rewrite/[diaryId].vue")
  },
  {
    name: "stories-storyId___tw",
    path: "/stories/:storyId()",
    meta: _91storyId_93jTQHLDc10KMeta || {},
    component: () => import("/vercel/path0/pages/stories/[storyId].vue")
  },
  {
    name: "stories-storyId___en",
    path: "/en/stories/:storyId()",
    meta: _91storyId_93jTQHLDc10KMeta || {},
    component: () => import("/vercel/path0/pages/stories/[storyId].vue")
  },
  {
    name: "terms___tw",
    path: "/terms",
    meta: index9OiDgfx7OcMeta || {},
    component: () => import("/vercel/path0/pages/terms/index.vue")
  },
  {
    name: "terms___en",
    path: "/en/terms",
    meta: index9OiDgfx7OcMeta || {},
    component: () => import("/vercel/path0/pages/terms/index.vue")
  },
  {
    name: "topics-topicId___tw",
    path: "/topics/:topicId()",
    meta: _91topicId_93J4gYD96o25Meta || {},
    component: () => import("/vercel/path0/pages/topics/[topicId].vue")
  },
  {
    name: "topics-topicId___en",
    path: "/en/topics/:topicId()",
    meta: _91topicId_93J4gYD96o25Meta || {},
    component: () => import("/vercel/path0/pages/topics/[topicId].vue")
  },
  {
    name: "write-date___tw",
    path: "/write/:date()",
    meta: _91date_93J39kcWxNzgMeta || {},
    component: () => import("/vercel/path0/pages/write/[date].vue")
  },
  {
    name: "write-date___en",
    path: "/en/write/:date()",
    meta: _91date_93J39kcWxNzgMeta || {},
    component: () => import("/vercel/path0/pages/write/[date].vue")
  },
  {
    name: component_45stub0StuoQ5MXtMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub0StuoQ5MXt
  }
]